import { BriefType } from "../../constants/types";
import { Nullable, TPageType } from "../../types/common";
import { RootState } from "../store";
import { LOADING_STATES } from "../../features/loading";
import { ApprovalStatus } from "../../types/approval-status/approval-status.type";
import { IError } from "../actions/errorHandlingAction";

export const selectErrors = (briefType: BriefType) => ({
  campaignBrief: { errors: campaignBriefErrors },
  executionBriefs: { errors: executionBriefErrors },
  workOrders: { errors: workOrderErrors },
}: RootState): Nullable<IError> => {
  switch (briefType) {
    case BriefType.CAMPAIGN_BRIEF:
      return campaignBriefErrors;
    case BriefType.EXECUTION_BRIEF:
      return executionBriefErrors;
    case BriefType.WORK_ORDER:
      return workOrderErrors;
  }
};

export const selectLoadingState = (briefType: BriefType) => ({
  campaignBrief: { loading: campaignBriefLoadingState },
  executionBriefs: { loading: executionBriefLoadingState },
  workOrders: { loading: workOrderLoadingState },
}: RootState): boolean => {
  switch (briefType) {
    case BriefType.CAMPAIGN_BRIEF:
      return campaignBriefLoadingState.status === LOADING_STATES.loading.status;
    case BriefType.EXECUTION_BRIEF:
      return executionBriefLoadingState.status === LOADING_STATES.loading.status;
    case BriefType.WORK_ORDER:
      return workOrderLoadingState.status === LOADING_STATES.loading.status;
  }
};

export const selectParentStatus = (pageType?: TPageType) => (state: RootState) => {
  switch (pageType) {
    case "execution-briefs":
      return state.executionBriefs.data.parentStatus;
    case "work-orders":
      return state.workOrders.data.parentStatus;
    case "campaign-briefs":
    default:
      return state.campaignBrief.data.status;
  }
};

export const selectPageStatus = (pageType?: TPageType) => ({
  campaignBrief: {
    data: { status: campaignStatus },
  },
  executionBriefs: {
    data: { status: executionBriefStatus },
  },
  workOrders: {
    data: { status: workOrdersStatus },
  },
}: RootState) => {
  switch (pageType) {
    case "execution-briefs":
      return executionBriefStatus as ApprovalStatus;
    case "work-orders":
      return workOrdersStatus as ApprovalStatus;
    case "campaign-briefs":
      return campaignStatus as ApprovalStatus;
    default:
      return campaignStatus as ApprovalStatus;
  }
};

export const selectPageOwnerId = (pageType: TPageType) => ({
  campaignBrief: {
    data: {
      briefOwner: { id: campaignBriefOwnerId },
    },
  },
  executionBriefs: {
    data: {
      briefOwner: { id: executionBriefOwnerId },
    },
  },
  workOrders: {
    data: {
      ownerDetail: { id: workOrderOwnerId },
    },
  },
}: RootState): Nullable<number> => {
  switch (pageType) {
    case "campaign-briefs":
      return campaignBriefOwnerId as number;
    case "execution-briefs":
      return executionBriefOwnerId as number;
    case "work-orders":
      return workOrderOwnerId as number;
    default:
      return null;
  }
};

export const selectParentPageStatus = (pageType: TPageType) => ({
  executionBriefs: { parentStatus: executionBriefParentStatus },
  workOrders: { parentStatus: workOrdersParentStatus },
}: RootState) => {
  switch (pageType) {
    case "execution-briefs":
      return executionBriefParentStatus;
    case "work-orders":
      return workOrdersParentStatus;
    case "campaign-briefs":
    default:
      return undefined;
  }
};
